// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentContainer_content-container__dCVyt {
  width: 90%;
}
.ContentContainer_content-container__dCVyt .ContentContainer_content-list-tags__DKFgt .ant-tag {
  font-size: 14px !important;
  padding: 7px 15px;
  border-radius: 50px;
}
.ContentContainer_content-container__dCVyt .ContentContainer_content-item__kA7Tq {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/ContentContainer/ContentContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACI;EACE,0BAAA;EACA,iBAAA;EACA,mBAAA;AACN;AAEE;EACE,gBAAA;AAAJ","sourcesContent":[".content-container {\n  width: 90%;\n  .content-list-tags {\n    :global(.ant-tag) {\n      font-size: 14px !important;\n      padding: 7px 15px;\n      border-radius: 50px;\n    }\n  }\n  .content-item {\n    margin-top: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content-container": `ContentContainer_content-container__dCVyt`,
	"content-list-tags": `ContentContainer_content-list-tags__DKFgt`,
	"content-item": `ContentContainer_content-item__kA7Tq`
};
export default ___CSS_LOADER_EXPORT___;
